import { Button, LinkButton } from '@cian/ui-kit';
import cx from 'clsx';
import * as React from 'react';

import * as styles from './styles.css';

interface IProps {
  className?: string;
  reviewsCount?: string | null;
  reviewsLink: string;
  onAllButtonClick: VoidFunction;
  onWriteButtonClick: VoidFunction;
}

export function ReviewsSnippetFooter({
  className,
  reviewsCount,
  reviewsLink,
  onAllButtonClick,
  onWriteButtonClick,
}: IProps) {
  const allButtonText = reviewsCount ? `Показать ${reviewsCount}` : 'Все отзывы';

  return (
    <div className={cx(styles['wrapper'], className)}>
      <Button theme="fill_primary" size="XS" onClick={onWriteButtonClick}>
        Написать отзыв
      </Button>
      <LinkButton theme="stroke_primary" size="XS" href={reviewsLink} onClick={onAllButtonClick}>
        {allButtonText}
      </LinkButton>
    </div>
  );
}
